export const apiKey = '74f8a48e9fd9179fa63b943af9d43cd0';
export const apiUrl = 'https://api.openweathermap.org/data/2.5/weather?';